import { APP } from 'libs/constants';
import { getEuroCountryCodeNameMap } from 'libs/geographicalRegion';
import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

const euroCountryCodeNameMap = getEuroCountryCodeNameMap();

const countryCodes = ['CA', 'US', 'AU'];

function getCountryCode(countryCode) {
  let _countryCode = 'US';

  if (countryCodes.includes(countryCode)) {
    _countryCode = countryCode.toUpperCase();
  } else if (countryCode === 'GB') {
    _countryCode = 'UK';
  } else if (euroCountryCodeNameMap[countryCode]) {
    _countryCode = 'EU';
  }

  return _countryCode;
}

export function fetchMuseAndroidPromoPlansApi({ countryCode }, coupon) {
  const { API } = config;
  const query = {};
  query.app = APP.muse;
  query.country_code = getCountryCode(countryCode);

  if (coupon) {
    query.coupon = coupon;
  }

  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.products}`,
    query
  });
}

export function checkoutMuseAndroidPromoPlanApi(payload, locale) {
  return apiCall({
    method: 'put',
    endpoint: endPoints.planCheckout,
    payload,
    query: {
      locale
    }
  });
}

export default {
  fetchMuseAndroidPromoPlansApi
};



// WEBPACK FOOTER //
// ./src/api/museAndroidPromo.js